import type React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useQueryParamValue } from 'src/app/shared/hooks/location';

import { useIsIndexed } from './hooks/useIsIndexed';

export const CanonicalUrlContainer: React.FC = () => {
	const utilityContext = useUtilityContext();
	const { pathname } = useLocation();
	const canonicalUrl = utilityContext.resolveUrl(pathname);

	// Includes best_share_visual=1 in og:url so Facebook's crawler fetches the correct OG image,
	// but exclude tracking params (utm_*, recruiter) to avoid fragmenting engagement and polluting analytics.
	// Related: supporter_growth_psf_share_assets_experiment (CHANGE-80701)
	const bestShareVisualParam = useQueryParamValue('best_share_visual');
	const ogUrlPath = bestShareVisualParam === '1' ? `${pathname}?best_share_visual=1` : pathname;
	const ogUrl = utilityContext.resolveUrl(ogUrlPath);

	const indexed = useIsIndexed();

	return (
		<Helmet>
			<meta property="og:url" content={ogUrl} />
			{/* only adding the canonical url if noindex is absent, as they are conflicting tags for SEO indexers */}
			{/* FIXME? should we use share urls here or should we use the simple /p/slug url? */}
			{indexed && <link rel="canonical" href={canonicalUrl} />}
		</Helmet>
	);
};
